import { DataAttributeDefinitions } from 'scrivito'

import { pisaSchemaDataClass } from './Pisa/pisaSchemaDataClass'

const attributes: DataAttributeDefinitions = {}

export const Schema = pisaSchemaDataClass(attributes)
